import { useCallback } from "react";
// Libraries
import { AxiosPromise } from "axios";
// API
import { eventsRequest, EventRequestBody } from "api/restAPI";
// Utils
import { useGetCurrentUserInfo, useStateSpecies } from "hooks";

interface UseEventRequestReturn {
  eventsRequest: (eventBody: EventRequestBody) => AxiosPromise;
}

export const useEventRequest = (): UseEventRequestReturn => {
  const { active: speciesActive } = useStateSpecies();

  const { data } = useGetCurrentUserInfo();
  const userEmail = data?.userInfo?.email || "";

  const eventRequestWithUser = useCallback(
    (eventBody: EventRequestBody): AxiosPromise => {
      return eventsRequest({ species: speciesActive?.name, username: userEmail, ...eventBody });
    },
    [speciesActive, userEmail],
  );

  return { eventsRequest: eventRequestWithUser };
};
